import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.5 26.5L22 22M22 22L26.5 17.5M22 22L17.5 17.5M22 22L26.5 26.5M42.25 22C42.25 24.6593 41.7262 27.2925 40.7086 29.7493C39.6909 32.2062 38.1993 34.4385 36.3189 36.3189C34.4385 38.1993 32.2062 39.6909 29.7493 40.7086C27.2925 41.7262 24.6593 42.25 22 42.25C19.3407 42.25 16.7075 41.7262 14.2507 40.7086C11.7938 39.6909 9.56147 38.1993 7.68109 36.3189C5.8007 34.4385 4.3091 32.2062 3.29144 29.7493C2.27378 27.2925 1.75 24.6593 1.75 22C1.75 16.6294 3.88348 11.4787 7.68109 7.68109C11.4787 3.88348 16.6294 1.75 22 1.75C27.3706 1.75 32.5213 3.88348 36.3189 7.68109C40.1165 11.4787 42.25 16.6294 42.25 22Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }